// Types
import { OBJECT_ID } from '../constants';
/**
 * Set the object id on the given object
 *
 * @param {object} values
 * @param {string} objectId
 *
 * @return {void}
 */
export var setObjectId = function (values, objectId) {
    Object.defineProperty(values, OBJECT_ID, {
        configurable: true,
        enumerable: true,
        value: objectId,
    });
};
//# sourceMappingURL=setObjectId.js.map